import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginModal: {
    visible: false,
    data: {},
  },
};

const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { name, data = null } =
        typeof action.payload === "string"
          ? { name: action.payload }
          : action.payload;
      state[name] = { visible: true, data };
    },
    closeModal: (state, action) => {
      const name =
        typeof action.payload === "string"
          ? action.payload
          : action.payload.name;
      if (state[name]) {
        state[name].visible = false;
        state[name].data = null;
      }
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;

export default modalsSlice.reducer;
